import React from 'react';
import { CheckIcon, ZapIcon, LockKeyholeIcon, ShieldCheckIcon, InfinityIcon, RulerIcon } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
import { salesPageData } from '../data/salesPageData';
const CHIPS = ['500+ planos y proyectos', '8 Bonos Especiales', 'Acceso digital', 'Acceso ilimitado', 'Pago único'];
const TRUST = [{
  icon: ZapIcon,
  label: 'Acceso digital'
}, {
  icon: LockKeyholeIcon,
  label: 'Pago seguro'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: InfinityIcon,
  label: 'Acceso ilimitado'
}];
export function HeroSection() {
  return <section id="top" className="relative overflow-hidden bg-[#111111]" aria-labelledby="hero-title" data-id="element-141" data-mp="2mufi418j3dbv">
      <div className="blueprint-grid absolute inset-0 opacity-60" aria-hidden="true" data-id="element-142" data-mp="2rsgy2danqwj4" />
      <div className="absolute -top-40 right-[-10%] h-[520px] w-[520px] rounded-full bg-[#FF7A00]/10 blur-[140px]" aria-hidden="true" data-id="element-143" data-mp="3fiutmdsgbdig" />
      <div className="wood-grain absolute bottom-0 left-0 h-24 w-full opacity-40" aria-hidden="true" data-id="element-144" data-mp="3ka365ip2vezu" />

      <div className="relative mx-auto flex max-w-content flex-col items-center gap-10 px-4 pb-16 pt-10 md:px-8 md:pb-24 md:pt-16" data-id="element-145" data-mp="2fgbmz6rn4jdz">
        {/* Texto */}
        <div className="text-center" data-id="element-146" data-mp="2p51vz2l3l7mh">
          <p className="inline-flex items-center gap-2 rounded-full border border-[#D89A3D]/35 bg-[#181512] px-3.5 py-1.5 font-display text-[10px] font-extrabold uppercase tracking-[0.18em] text-[#D89A3D] sm:text-xs" data-id="element-147" data-mp="2p63ka8r4jqm5">
            🔐 Más de 500 proyectos esperándote adentro
          </p>

          <h1 id="hero-title" className="title-glow mt-5 font-display text-[2rem] font-black uppercase leading-[1.04] tracking-tight text-[#F8F3EA] sm:text-[2.9rem] lg:text-[3.4rem]" data-id="element-148" data-mp="2u3d5tdbe7i4p">
            Convertí tus <span className="text-[#D89A3D]" data-id="element-149" data-mp="3365wpfgnxru0">ganas de hacer carpintería</span>{' '}
            en <span className="accent-glow text-[#FF7A00]" data-id="element-150" data-mp="1dpn1q6k9wtv2">proyectos concretos.</span>
          </h1>
          

          {/* Mockup centrado */}
          <div className="mt-10 mb-8 w-full max-w-[640px] mx-auto" data-id="element-151" data-mp="18swijad69i5f">
            <HeroMockup data-id="element-152" data-mp="38ucv4nn1g7iw" />
          </div>

          <p className="mx-auto max-w-3xl text-[15px] leading-relaxed text-[#EFEDE8]/80 sm:text-lg" data-id="element-153" data-mp="38vfp54fnqq31">
            <span className="font-semibold text-[#F8F3EA]" data-id="element-154" data-mp="3du91gtj7kb1m">La Bóveda del Carpintero</span>{' '}
            reúne planos, medidas, ideas y recursos para que sepas{' '}
            <span className="font-semibold text-[#D89A3D]" data-id="element-155" data-mp="3mtvv2t5p4ck4">qué fabricar</span>,{' '}
            <span className="font-semibold text-[#D89A3D]" data-id="element-156" data-mp="3rr5r4rnlbmgx">cómo empezar</span> y{' '}
            <span className="font-semibold text-[#D89A3D]" data-id="element-157" data-mp="lcr05g6to3u">qué proyecto hacer después</span>.
          </p>

          <p className="mt-4 font-display text-sm font-extrabold uppercase tracking-[0.06em] text-[#FF7A00] sm:text-base" data-id="element-158" data-mp="5cckt1u0fq24">
            Abrí la Bóveda y elegí qué vas a fabricar.
          </p>

          <p className="mx-auto mt-7 max-w-[58ch] text-[15px] leading-relaxed text-[#EFEDE8]/75 sm:text-base" data-id="element-159" data-mp="ee2ao388ugxs">
            {salesPageData.subtitle}
          </p>

          <ul className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-160" data-mp="ja14i6cccr5l">
            {CHIPS.map(chip => <li key={chip} className="premium-card flex items-center gap-1.5 rounded-md border border-[#D89A3D]/25 bg-[#181512] px-3 py-1.5 text-[11px] font-semibold uppercase tracking-wide text-[#EFEDE8]/85 sm:text-xs" data-id="element-161" data-mp="23sbpm4hecr9x">
                <CheckIcon className="h-3.5 w-3.5 text-[#FF7A00]" aria-hidden="true" data-id="element-162" data-mp="1pun6b12z9s6z" />
                {chip}
              </li>)}
          </ul>

          <p className="mt-6 text-sm leading-relaxed text-[#EFEDE8]/60" data-id="element-163" data-mp="2mjmdecrtsnxl">
            Muebles para tu casa.
            <br className="hidden sm:block" data-id="element-164" data-mp="2ijudeoghzq3u" /> Proyectos para aprender.
            <br className="hidden sm:block" data-id="element-165" data-mp="2drsqm8lpegzk" /> Ideas para desarrollar trabajos para
            clientes.
          </p>

          <div className="mt-8" data-id="element-166" data-mp="28spzls2k6bal">
            <CTAButton href="#oferta" size="large" data-id="element-167" data-mp="28rerxh5zsje7">
              🔓 Quiero acceder ahora
            </CTAButton>
            <p className="mt-3 text-xs text-[#EFEDE8]/55" data-id="element-168" data-mp="31i6oifqyza22">
              Pago único · Acceso digital · Garantía 7 días
            </p>
          </div>

          <ul className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 border-t border-[#EFEDE8]/10 pt-6" data-id="element-169" data-mp="2l1w6wnfzu34t">
            {TRUST.map(item => <li key={item.label} className="flex items-center justify-center gap-2 text-[11px] font-semibold uppercase tracking-wide text-[#EFEDE8]/65" data-id="element-170" data-mp="2c1zau0r9y1zq">
                <item.icon className="h-4 w-4 text-[#D89A3D]" aria-hidden="true" data-id="element-171" data-mp="2h1vic9z6kbk1" />
                {item.label}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}
function HeroMockup() {
  return <div className="relative mx-auto w-full max-w-[560px]" data-id="element-172" data-mp="38rgob1wi0sbz">
      <div className="absolute inset-6 rounded-full bg-[#FF7A00]/18 blur-[90px]" aria-hidden="true" data-id="element-173" data-mp="2v1myag99c20o" />
      <div className="absolute -left-3 top-6 hidden h-24 w-px bg-gradient-to-b from-transparent via-[#D89A3D]/40 to-transparent lg:block" aria-hidden="true" data-id="element-174" data-mp="2zz52jtcbxt2c" />
      <div className="absolute -right-3 bottom-10 hidden h-24 w-px bg-gradient-to-b from-transparent via-[#D89A3D]/40 to-transparent lg:block" aria-hidden="true" data-id="element-175" data-mp="3nnoau8vdq5uf" />
      <img src={salesPageData.mainMockup} alt="Mockup de La Bóveda del Carpintero: el libro principal rodeado por las fichas de categorías de proyectos" className="relative w-full [filter:drop-shadow(0_0_6px_rgba(255,122,0,0.75))_drop-shadow(0_0_22px_rgba(255,122,0,0.5))_drop-shadow(0_0_55px_rgba(216,154,61,0.3))_drop-shadow(0_26px_40px_rgba(0,0,0,0.65))]" width={1080} height={1080} loading="eager" data-id="element-176" data-mp="5o3r7xyscn6w" />
      <div className="relative mt-4 flex items-center justify-center gap-2 text-[10px] font-semibold uppercase tracking-[0.2em] text-[#EFEDE8]/45" data-id="element-177" data-mp="3iwox0yc6xt2d">
        <RulerIcon className="h-3.5 w-3.5 text-[#D89A3D]" aria-hidden="true" data-id="element-178" data-mp="3su30zygxgpds" />
        500+ proyectos · Una sola Bóveda
      </div>
    </div>;
}